var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownloadIcon = function SvgDownloadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "download-icon_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#download-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FDFDFD",
    d: "m12 16-5-5 1.4-1.45 2.6 2.6V4h2v8.15l2.6-2.6L17 11zm-6 4q-.824 0-1.412-.587A1.93 1.93 0 0 1 4 18v-3h2v3h12v-3h2v3q0 .824-.587 1.413A1.93 1.93 0 0 1 18 20z"
  }))));
};
export { SvgDownloadIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPG1hc2sgaWQ9Im1hc2swXzE5NzVfMjM2MjMiIHN0eWxlPSJtYXNrLXR5cGU6YWxwaGEiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjAiIHk9IjAiIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCI+CjxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0iI0Q5RDlEOSIvPgo8L21hc2s+CjxnIG1hc2s9InVybCgjbWFzazBfMTk3NV8yMzYyMykiPgo8cGF0aCBkPSJNMTIgMTZMNyAxMUw4LjQgOS41NUwxMSAxMi4xNVY0SDEzVjEyLjE1TDE1LjYgOS41NUwxNyAxMUwxMiAxNlpNNiAyMEM1LjQ1IDIwIDQuOTc5MTcgMTkuODA0MiA0LjU4NzUgMTkuNDEyNUM0LjE5NTgzIDE5LjAyMDggNCAxOC41NSA0IDE4VjE1SDZWMThIMThWMTVIMjBWMThDMjAgMTguNTUgMTkuODA0MiAxOS4wMjA4IDE5LjQxMjUgMTkuNDEyNUMxOS4wMjA4IDE5LjgwNDIgMTguNTUgMjAgMTggMjBINloiIGZpbGw9IiNGREZERkQiLz4KPC9nPgo8L3N2Zz4K";